import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  FaUserGraduate,
  FaMoneyBillWave,
  FaSchool,
  FaExclamationCircle,
  FaBus,
  FaChartPie,
} from "react-icons/fa";

import { motion } from "framer-motion";
import { useAuth } from "../../../../AuthProvider";

const AdmissionReportsScreen = () => {
  const navigate = useNavigate();
  const {feature} = useAuth();

  const reportItems = [
    {
      number: "01",
      label: "New Admission Reports",
      path: "/NewAdmissionReports",
      color: "#3949AB",
      icon: <FaUserGraduate size={26} />,
    },
    {
      number: "02",
      label: "Admission Fee Paid",
      path: "/AdmissionFeePaidReports",
      color: "#43A047",
      icon: <FaMoneyBillWave size={26} />,
    },
    {
      number: "03",
      label: "Tuition Fee Paid",
      path: "/TuitionFeePaidReports",
      color: "#0288D1",
      icon: <FaSchool size={26} />,
    },
    {
      number: "04",
      label: "Tuition Fee Unpaid",
      path: "/TuitionFeeUnpaidReports",
      color: "#F4511E",
      icon: <FaExclamationCircle size={26} />,
    },

    ...(feature === "CORE" || feature === "ULTRA"
      ? [
         {
      number: "05",
      label: "Bus Fee Paid",
      path: "/BusFeePaidReports",
      color: "#00796B",
      icon: <FaBus size={26} />,
    },
    {
      number: "06",
      label: "Bus Fee Unpaid",
      path: "/BusFeeUnpaidReports",
      color: "#C62828",
      icon: <FaExclamationCircle size={26} />,
    },
 
        ]
      : []), // Don't include 'Packages' if not ULTRA
    // {
    //   number: "05",
    //   label: "Bus Fee Paid",
    //   path: "/BusFeePaidReports",
    //   color: "#00796B",
    //   icon: <FaBus size={26} />,
    // },
    // {
    //   number: "06",
    //   label: "Bus Fee Unpaid",
    //   path: "/BusFeeUnpaidReports",
    //   color: "#C62828",
    //   icon: <FaExclamationCircle size={26} />,
    // },
    {
      number: "07",
      label: "Expenses",
      path: "/AdmissionExpensesReports",
      color: "#6A1B9A",
      icon: <FaChartPie size={26} />,
    },
  ];

  const cardVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        type: "spring",
        stiffness: 80,
      },
    }),
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      {/* Header */}
      <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "black", mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold">
          Admission Reports
        </Typography>
      </Box>

      {/* Main Card */}
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          minHeight: "500px",
          padding: "20px",
          width: "95%",
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          
        }}
      >
        <CardContent
        sx={{
          width: "100%",
          padding: 0,
        }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 4,
              padding: 2,
            }}
          >
            {reportItems.map((item, idx) => (
              <motion.div
                key={idx}
                custom={idx}
                variants={cardVariant}
                initial="hidden"
                animate="visible"
                style={{ perspective: "1000px" }}
              >
                <Box
  onClick={() => navigate(item.path)}
  sx={{
    position: "relative",
    width: 180, // slightly narrower
    padding: "12px 10px", // reduced padding
    minHeight: "130px", // reduced height
    borderRadius: "14px",
    backgroundColor: "#f4f5f7",
    boxShadow: `
                      4px 4px 12px rgba(0, 0, 0, 0.2),     /* right + bottom */
                      0 4px 6px rgba(0, 0, 0, 0.1)          /* soft shadow */
                    `,
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    textAlign: "center",
    "&:hover": {
      transform: "translateY(-4px) rotateY(3deg) rotateX(1.5deg)",
      boxShadow: `
                        6px 8px 24px rgba(0, 0, 0, 0.25),    /* enhanced right + bottom */
                        0 4px 16px rgba(0, 0, 0, 0.12)
                      `,
    },
  }}
>

                  {/* Side Accent */}
                 <Box
                                           sx={{
                                             position: "absolute",
                                             top: 0,
                                             bottom: 0,
                                             left: -8, // <-- changed from right
                                             width: "8px",
                                             borderTopLeftRadius: "12px",
                                             borderBottomLeftRadius: "12px",
                                             backgroundColor: item.color,
                                           }}
                                         />

                 {/* Icon */}
                                                           <Box sx={{ mb: 2, color: item.color }}>{item.icon}</Box>
                                                 
                                                           {/* Label */}
                                                           <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                             {item.label}
                                                           </Typography>
                                                 
                                                           {/* Description */}
                                                           <Typography
                                                             variant="body2"
                                                             sx={{ color: "#666", mb: 2, minHeight: "40px" }}
                                                           >
                                                             Click to view report
                                                           </Typography>
                                                 
                                                           {/* Number Circle */}
                                                           <Box
                                                             sx={{
                                                               width: 36,
                                                               height: 36,
                                                               borderRadius: "50%",
                                                               backgroundColor: item.color,
                                                               color: "#fff",
                                                               display: "flex",
                                                               alignItems: "center",
                                                               justifyContent: "center",
                                                               fontWeight: "bold",
                                                               fontSize: 14,
                                                               mx: "auto",
                                                             }}
                                                           >
                                                             {item.number}
                                                           </Box>
                </Box>
              </motion.div>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdmissionReportsScreen;